import PropTypes from 'prop-types';
import React from 'react';

import Heading from 'app/components/shared/Heading';
import Tabs from 'app/components/shared/Tabs';
import { tabsOptionShape } from 'app/components/shared/Tabs/shapes'; // TODO: move this into app/shapes

import './AdminBrowseCategoriesListPage.scss';

const AdminBrowseCategoriesListPage = ({ onTabSelected, tabOptions, topLevelCategoryId }) => {
  return (
    <div className="cp-admin-browse-categories-list-page container">
      <Heading className="heading" size="large" tagName="h1" variant>
        Browse: Categories Editor
      </Heading>

      <Tabs
        ariaLabel="TODO: Choose top-level category"
        classNameTabList="tab-list"
        initialSelectedOptionId={topLevelCategoryId}
        key={topLevelCategoryId}
        onTabSelected={onTabSelected}
        options={tabOptions}
      />
    </div>
  );
};

AdminBrowseCategoriesListPage.propTypes = {
  onTabSelected: PropTypes.func.isRequired,
  tabOptions: PropTypes.arrayOf(tabsOptionShape).isRequired,
  topLevelCategoryId: PropTypes.string.isRequired
};

export default AdminBrowseCategoriesListPage;
